import DataStore from 'src/core/stores/data-store';
import { CsvReportKeys as IdentityCsvReportKeys } from './users-store';
import { CommandResult } from 'src/core/stores/types';

export interface ToolUsageSummary {
  organizationName: string;
  projectName: string;
  toolType: string;
  toolSerialNumber: string;
  firstUsedOn: string;
  lastUsedOn: string;
  measurementCount: number;
}

export interface ReportHeader {
  key: ToolUsageCsvReportKeys;
  translatedHeader: string;
}

export interface ToolUsageCsvReportRequest {
  csvSeparator: string;
  headers: ReportHeader[];
  currentLanguage: string;
}

export enum ToolUsageCsvReportKeys {
  OrganizationName = IdentityCsvReportKeys.OrganizationName,
  ProjectName = IdentityCsvReportKeys.ProjectName,
  ToolType = IdentityCsvReportKeys.ToolType,
  ToolSerialNumber = IdentityCsvReportKeys.ToolSerialNumber,
  FirstUsedOn = IdentityCsvReportKeys.FirstUsedOn,
  LastUsedOn = IdentityCsvReportKeys.LastUsedOn,
  MeasurementCount = IdentityCsvReportKeys.MeasurementCount,
}

export class ToolUsageReportStore extends DataStore<ToolUsageSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/organizations/tool-usage-report`, []);
  }

  public async getReport(item: ToolUsageCsvReportRequest) {
    return await this.handleCallAsync(async () => {
      var response = await this.httpService.post<any, CommandResult<any>>(`${this.baseUrl}/all-organizations`, item);
      return response.data.isSuccess;
    });
  }
}
